import {Chip} from "@material-ui/core";
import { FunctionField } from "react-admin";
import { Record } from "ra-core";
import React from "react";

const statusReference: any = {
    P: ["Pagata", "#4CAF50"],
    PP: ["Pagata parzialmente", "#FF9800"],
    CR: ["Creata", "#2196F3"],
    C: ["Completata", "#8BC34A"],
    ST: ["Stampata", "#3F51B5"],
};


export function InvoiceStatusField() {
    return (
        <FunctionField
            label="Stato"
            source="status"
            render={(record: Record | undefined) => {
                const status = record?.status ? statusReference[record.status] : undefined;
                if (!status) return null;


                return (
                    <Chip
                        label={status[0]}
                        style={{
                            backgroundColor: status[1],
                            color: "white",
                            height: "24px",
                            fontWeight: "bold",
                            width: "100px",
                            justifyContent: "center",
                        }}
                    />
                );
            }}
        />
    );
}
